import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import Select from 'react-select';
import HierarchyFieldSelector from './HierarchyFieldSelectorComponent.jsx';
import DeleteFile from '../../views/content/stores/deleteFile.js';
import PreviewFile from '../../views/content/stores/previewFile.js';
import ImportFile from '../../views/content/stores/importFile.js';

class StoreHierarchyWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedField: '',
      fieldLevel: '',
      options: [],
      selectedFile: '',
      fileType: '',
    };
    this.previewFile = new PreviewFile();
    this.importFile = new ImportFile();
    this.deleteFile = new DeleteFile('', true);
    this.updateFieldFiles = this.updateFieldFiles.bind(this);
  }

  handleDropdownChange(e, attribute) {
    this.setState({ [attribute]: e });
  }

  getWarningMessage() {
    const { storesHierarchyDefinition: definition } = this.props;
    const { selectedField: field } = this.state;

    return field
      ? `No files found in ${field.label} ${definition.name}.`
      : `Please select a ${definition.name}.`;
  }

  preview(e) {
    const { selectedField, selectedFile, fileType } = this.state;

    let data = {
      owner_type: 'hierarchy', // eslint-disable-line camelcase
      owner_id: selectedField.value.toString(), // eslint-disable-line camelcase
      filename: selectedFile.value,
      original_file: fileType.value === 'tags', // eslint-disable-line camelcase
    };

    this.previewFile.showXMLModal(e, data);
  }

  hasWarning() {
    const { selectedField, fieldLevel, options } = this.state;

    return selectedField
      ? options.length === 0
      : fieldLevel == this.props.storesHierarchyDefinition.level;
  }

  updateFieldFiles(selectedField, fieldLevel) {
    if (
      selectedField &&
      fieldLevel == this.props.storesHierarchyDefinition.level
    ) {
      fetch(
        `${window.location.origin}/${currentCustomer}/hierarchy_fields/${selectedField.value}/store_files`,
      )
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            selectedField: selectedField,
            fieldLevel: fieldLevel,
            options: data.map((file) => ({
              value: file.file_data.filename,
              label: file.file_data.filename,
            })),
          });
        });
    } else {
      this.setState({ selectedField: '', fieldLevel: fieldLevel, options: [] });
    }
  }

  render() {
    const { definitions, canImportFiles, title, canDeleteFiles } = this.props;
    const { selectedField, selectedFile, options, fileType } = this.state;

    return (
      <div className='StoreHierarchyWidget'>
        <h4>{`Template files for various ${title}`}</h4>
        <HierarchyFieldSelector
          definitions={definitions}
          name=''
          onChange={this.updateFieldFiles}
        />

        <If condition={this.hasWarning()}>
          <p>{this.getWarningMessage()}</p>
        </If>

        <If condition={canImportFiles && (this.hasWarning() || selectedField)}>
          <Button
            primary
            className='small'
            content='Import Config Templates'
            icon='upload'
            id='bt_import_template_hierarchy'
            onClick={(e) =>
              this.importFile.showFileImportModal(e, selectedField.value)
            }
          />
        </If>

        <If condition={selectedField && !this.hasWarning()}>
          <div className='hierarchy-field-actions preview-file-dropdown'>
            <Select
              className='file-to-preview'
              clearable={false}
              id='hierarchy_preview_file'
              options={options}
              value={selectedFile}
              onChange={(e) => this.handleDropdownChange(e, 'selectedFile')}
            />
            <Select
              className='file-type'
              clearable={false}
              id='hierarchy_preview_file_type'
              options={[
                { value: 'tags', label: 'Preview of Template Tags' },
                { value: 'data', label: 'Preview of Template Data' },
              ]}
              value={fileType}
              onChange={(e) => this.handleDropdownChange(e, 'fileType')}
            />

            <div className='actions'>
              <Button
                primary
                className='preview-file hierarchy-preview-file small'
                content='Preview'
                disabled={!this.state.selectedFile}
                icon='unhide'
                onClick={(e) => this.preview(e)}
              />

              <If condition={canDeleteFiles}>
                <Button
                  className='delete-file-button small'
                  color='red'
                  content='Delete'
                  disabled={!this.state.selectedFile}
                  icon='trash'
                  id='bt_delete_template_hierarchy'
                  onClick={(e) => {
                    e.target.blur();
                    this.deleteFile.delete({
                      owner: selectedField.value,
                      fileName: selectedFile.value,
                    });
                  }}
                />
              </If>
            </div>
          </div>
        </If>
      </div>
    );
  }
}

module.exports = StoreHierarchyWidget;
